import { render, staticRenderFns } from "./vaccinActions.vue?vue&type=template&id=77b310c4"
import script from "./vaccinActions.vue?vue&type=script&lang=js"
export * from "./vaccinActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports